import { Compass } from 'lucide-react';
import { useAuthStore, selectIsPro } from '../stores/authStore';
import { FREE_PLAN_BASE_LIMIT } from '../utils/planLimits';
import { useTourStore } from './tourStore';
import { bannerSichtbar, statusUpdate, tourEreignis } from './tourLogik';

// Angebot der App-Tour über dem Rechner. Ersetzt den früheren
// Willkommens-Banner; Status steht im Profil, nichts im Browser.
export function TourBannerAnsicht({ isPro, onStart, onSpaeter, onNie }) {
  return (
    <div role="region" aria-label="Einführung" className="mx-3 mt-3 md:mx-6 md:mt-4 rounded-2xl border border-line bg-surface shadow-sm"
      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', flexWrap: 'wrap' }}>
      <div className="text-brand" style={{ display: 'flex' }}><Compass size={20} aria-hidden="true" /></div>
      <div style={{ flex: 1, minWidth: 220 }}>
        <div className="text-ink font-semibold" style={{ fontSize: 14 }}>Neu hier? In einer Minute zeigen wir dir, was wo ist.</div>
        {!isPro && (
          <div className="text-ink-3" style={{ fontSize: 12 }}>
            Free-Plan: {FREE_PLAN_BASE_LIMIT} Rechnungen/Monat · ISO 2768-m · WC + RSS
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" onClick={onStart} className="bg-brand text-white font-semibold hover:bg-[var(--color-brand-2)] transition-colors" style={{ height: 32, padding: '0 14px', borderRadius: 8, cursor: 'pointer' }}>Tour starten</button>
        <button type="button" onClick={onSpaeter} className="text-ink-2 border border-line hover:bg-surface-2 hover:text-ink transition-colors" style={{ height: 32, padding: '0 12px', borderRadius: 8, cursor: 'pointer' }}>Später</button>
        <button type="button" onClick={onNie} className="text-ink-3 hover:text-ink hover:underline" style={{ height: 32, padding: '0 8px', cursor: 'pointer' }}>Nicht mehr anzeigen</button>
      </div>
    </div>
  );
}

export default function TourBanner() {
  const profile = useAuthStore((s) => s.profile);
  const isPro = useAuthStore(selectIsPro);
  const { spaeter, aktiv, setSpaeter, anfordern } = useTourStore();
  if (!bannerSichtbar({ profile, spaeter, aktiv })) return null;

  const nie = async () => {
    setSpaeter();
    tourEreignis('nie');
    try { await useAuthStore.getState().updateProfile(statusUpdate('dismissed')); }
    catch (e) { console.warn('Tour-Status nicht gespeichert:', e); }
  };

  return <TourBannerAnsicht isPro={isPro} onStart={anfordern} onSpaeter={setSpaeter} onNie={nie} />;
}
